var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"auth-src",rawName:"v-auth-src",value:(_vm.mediaBasePath + _vm.mediaItemData.filePath),expression:"mediaBasePath + mediaItemData.filePath"}],attrs:{"alt":_vm._f("cleanString")(_vm.mediaItemData.name)}})}
var staticRenderFns = []

export { render, staticRenderFns }